/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#actions[_ngcontent-%COMP%]   button.btn-danger-outline[_ngcontent-%COMP%], #actions[_ngcontent-%COMP%]   button.btn-outline[_ngcontent-%COMP%]{float:right}.comments-container[_ngcontent-%COMP%]{padding:1rem}h2[_ngcontent-%COMP%]{margin-top:0}section[_ngcontent-%COMP%]:not(:first-of-type){margin-top:1rem}"];
export { styles as styles };

